var map = {
	"./banner2.webp": 6640,
	"./ellipse.png": 6058,
	"./first-veri.png": 5457,
	"./firstveri1.webp": 2737,
	"./firstveri2.webp": 1140,
	"./img1.webp": 9922,
	"./img2.webp": 4195,
	"./line1.webp": 5929,
	"./line2-01.webp": 4304,
	"./line3-01.webp": 6005,
	"./line3-02.webp": 6600,
	"./line4.webp": 3202,
	"./line5-01.webp": 9943,
	"./line5-02.webp": 7606,
	"./logo.svg": 7629,
	"./v-app.jpg": 9684,
	"./veri.png": 6530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5332;